export default "__VITE_ASSET__DTMwJYXa__"